import React from "react";
import { AbsoluteFill, useCurrentFrame, interpolate } from "remotion";

interface ImpactShakeProps {
  children: React.ReactNode;
  impactFrames: number[]; // Frames where an impact shake occurs
  intensity?: number;     // Pixel amplitude (default 8px)
  duration?: number;      // Frames duration of shake decay (default 8)
}

export const ImpactShake: React.FC<ImpactShakeProps> = ({
  children,
  impactFrames,
  intensity = 8,
  duration = 8,
}) => {
  const frame = useCurrentFrame();

  let currentShakeX = 0;
  let currentShakeY = 0;

  for (const impact of impactFrames) {
    if (frame >= impact && frame < impact + duration) {
      const elapsed = frame - impact;
      const decay = interpolate(elapsed, [0, duration], [1, 0], {
        extrapolateRight: "clamp",
      });
      // High frequency vibration
      currentShakeX = Math.sin(elapsed * 2.8) * intensity * decay;
      currentShakeY = Math.cos(elapsed * 2.8) * (intensity * 0.7) * decay;
      break;
    }
  }

  return (
    <AbsoluteFill
      style={{
        transform: `translate(${currentShakeX}px, ${currentShakeY}px)`,
      }}
    >
      {children}
    </AbsoluteFill>
  );
};
